import { useLocation } from 'react-router-dom'

// ADR-0069: routes are mounted at /modules/{name}; the legacy
// /environments/{name} pattern is no longer emitted by the router
// but is kept here as a fallback so any in-flight bookmarks resolve.
const MODULE_ROUTE_RE = /^\/modules\/([^/]+)/
const LEGACY_ENVIRONMENT_ROUTE_RE = /^\/environments\/([^/]+)/

interface ActiveModule {
  name: string
  displayName: string
}

export function useActiveModule(): ActiveModule | null {
  const location = useLocation()
  const match =
    MODULE_ROUTE_RE.exec(location.pathname) ?? LEGACY_ENVIRONMENT_ROUTE_RE.exec(location.pathname)

  const name = match?.[1]
  if (!name) return null

  return {
    name,
    displayName: name,
  }
}
